import styled from 'styled-components';
import BodyText from '../../../common/BodyText';
import Devider from '../../../common/Devider';
import QuizOption from '../../Quiz/components/QuizOption';

const Container = styled.div`
  padding: 15px 0 0;
`;

const Title = styled.h3`
  margin-bottom: 15px;
`;

const Body = styled.p`
  margin-bottom: 15px;
  margin-top: 20px;
`;

const ResultItem = ({
  data,
  showCorrectAnswers
}) => {
  const {
    title,
    options,
    wrongAnswerFeedback,
    correctAnswerFeedback,
    question,
    correctOption,
    passed
  } = data;
  if (!showCorrectAnswers && passed) return null;
  return (
    <Container>
      <Title>{title}</Title>
      <BodyText>
        <Body dangerouslySetInnerHTML={{ __html: question }} />
      </BodyText>
      {
        options.map(({
          correct,
          label,
          selected,
          nuetral,
          id
        }) => (
          <QuizOption
            key={id}
            correct={correct}
            selected={selected}
            nuetral={nuetral}
            // eslint-disable-next-line no-nested-ternary
            state={id === correctOption ? 'correct' : (selected) ? 'wrong' : ''}
            isResult
          >
            {label}
          </QuizOption>
        ))
      }
      <Body
        dangerouslySetInnerHTML={{
          __html: passed ? correctAnswerFeedback : wrongAnswerFeedback
        }}
      />
      <Devider />
    </Container>
  );
};

export default ResultItem;
